import { Box } from '@wix/design-system';
import React, { FC, Fragment } from 'react';

import { Attachment } from '../../../../../types';
import { ScrollContainerHorizontal } from '../../../../common/components/ScrollContainerHorizontal';
import { AttachmentPreview } from './AttachmentPreview';

export type AttachmentsPreviewProps = Readonly<{
  attachments?: Attachment[];
}>;

export const AttachmentsPreview: FC<AttachmentsPreviewProps> = ({ attachments }) => {
  return (
    <ScrollContainerHorizontal>
      <Box gap="SP1">
        {attachments?.map((attachment) => (
          <Fragment key={attachment.url}>
            <AttachmentPreview attachment={attachment} />
          </Fragment>
        ))}
      </Box>
    </ScrollContainerHorizontal>
  );
};
